
const BASE_URL = "https://bannerwala-backend.onrender.com/api";
//  const BASE_URL = "http://localhost:5000/api";

export const API_URLS = {
    CATEGORIES: `${BASE_URL}/categories`,
    SUB_CATEGORIES: `${BASE_URL}/sub-categories`,
    USERS: `${BASE_URL}/users`,
    SUBSCRIPTION_PLANS: `${BASE_URL}/subscription-plans`,
    LOGIN: `${BASE_URL}/users/login`,
    SEND_OTP: `${BASE_URL}/users/send`,
    TEMPLATES: `${BASE_URL}/templates`,
};
